'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AxisContainer = undefined;

var _Style = require('./Style');

var _Style2 = _interopRequireDefault(_Style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AxisContainer = function AxisContainer(refs) {
    var i18n = refs.i18nManager.get();

    var container = Ext.create('Ext.container.Container', {
        bodyStyle: 'border:0 none',
        style: 'margin-left:14px'
    });

    container.rangeAxisMinValueInput = Ext.create('Ext.form.field.Number', {
        width: _Style2.default.numberWidth,
        height: _Style2.default.numberHeight,
        labelWidth: _Style2.default.labelWidth
    });

    container.rangeAxisMaxValueInput = Ext.create('Ext.form.field.Number', {
        width: _Style2.default.numberWidth,
        height: _Style2.default.numberHeight,
        labelWidth: _Style2.default.labelWidth,
        style: 'margin-left:1px'
    });

    container.rangeAxisStepsInput = Ext.create('Ext.form.field.Number', {
        width: _Style2.default.labelWidth + 5 + _Style2.default.numberWidth,
        height: _Style2.default.numberHeight,
        fieldLabel: 'Range axis tick steps',
        labelSeparator: null,
        labelStyle: 'color:#333',
        labelWidth: _Style2.default.labelWidth,
        minValue: 1
    });

    container.rangeAxisDecimalsInput = Ext.create('Ext.form.field.Number', {
        width: _Style2.default.labelWidth + 5 + _Style2.default.numberWidth,
        height: _Style2.default.numberHeight,
        fieldLabel: 'Range axis decimals',
        labelSeparator: null,
        labelStyle: 'color:#333',
        labelWidth: _Style2.default.labelWidth,
        minValue: 0,
        maxValue: 20
    });

    container.rangeAxisTitleInput = Ext.create('Ext.form.field.Text', {
        width: _Style2.default.cmpWidth,
        fieldLabel: i18n.range_axis_label,
        emptyText: i18n.range_axis_label,
        labelSeparator: null,
        labelStyle: 'color:#333',
        labelWidth: _Style2.default.labelWidth,
        maxLength: 100,
        enforceMaxLength: true,
        style: 'margin-bottom:1px'
    });

    container.domainAxisTitleInput = Ext.create('Ext.form.field.Text', {
        width: _Style2.default.cmpWidth,
        fieldLabel: i18n.domain_axis_label,
        emptyText: i18n.domain_axis_label,
        labelSeparator: null,
        labelStyle: 'color:#333',
        labelWidth: _Style2.default.labelWidth,
        maxLength: 100,
        enforceMaxLength: true,
        style: 'margin-bottom:1px'
    });

    container.add([{
        layout: 'column',
        bodyStyle: 'border:0 none',
        items: [{
            bodyStyle: 'border:0 none; padding-top:3px; margin-right:5px; color:#333',
            width: 130,
            html: 'Range axis min/max'
        }, container.rangeAxisMinValueInput, container.rangeAxisMaxValueInput]
    }, container.rangeAxisStepsInput, container.rangeAxisDecimalsInput, container.rangeAxisTitleInput, container.domainAxisTitleInput]);

    return container;
};

exports.AxisContainer = AxisContainer;
exports.default = AxisContainer;
//# sourceMappingURL=Axis.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/options/Axis.js
 ** module id = 350
 ** module chunks = 0
 **/